<template>
<!-- About Start -->
<section id="about" class="about">
    <div class="about-decor">
        <div class="about-circle1"><img :src='"../assets/images/team1.png"' alt="team1"></div>
        <div class="about-circle2"><img :src='"../assets/images/main-banner1.png"' alt="banner1"></div>
    </div>
    <div class="container">
        <div class="row ">
            <div class="col-md-8">
                <div class="about-contain">
                    <div>
                        <h2 class="title">A propos de <span>Clean Touch Protect</span></h2>
                        <p class="caption-about">La société SFP innove et lance un nouveau film adhésif
                            antimicrobien efficace contre les coronavirus .
                            Ce film est une barrière sanitaire efficace qui sécurise,
                            protège et assainit votre environnement.</p>
                        <div class="row sm-mb">
                            <div class="col-6">
                                <ul class="about-style">
                                    <li class="abt-hover">
                                        <div class="about-icon">
                                            <div class="icon-hover">
                                                <i class="fas fa-umbrella"></i>
                                            </div>
                                        </div>
                                        <div class="about-text">
                                            <h3>Parfaitement étanche</h3>
                                        </div>
                                    </li>
                                    <li class="abt-hover">
                                        <div class="about-icon">
                                            <div class="icon-hover">
                                                <i class="fas fa-tachometer-alt"></i>
                                            </div>
                                        </div>
                                        <div class="about-text">
                                            <h3>Application rapide</h3>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-6">
                                <ul class="about-style">
                                    <li class="abt-hover">
                                        <div class="about-icon">
                                            <div class="icon-hover">
                                                <i class="fas fa-hand-sparkles"></i>
                                            </div>
                                        </div>
                                        <div class="about-text">
                                            <h3>Facile à nettoyer</h3>
                                        </div>
                                    </li>
                                    <li class="abt-hover">
                                        <div class="about-icon">
                                            <div class="icon-hover">
                                                <i class="fas fa-hand-rock"></i>
                                            </div>
                                        </div>
                                        <div class="about-text">
                                            <h3>Résistant</h3>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                       
                    </div>
                </div>
            </div>
            <div class="col-md-4 d-medium-none">
                <div class="about-right">
                    <div class="about-phone">
                        <img :src='"../assets/images/logo.png"' class="img-fluid" alt="logo">
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- About End -->
</template>

<script>
export default {
    name: 'about'
}
</script>



// WEBPACK FOOTER //
// src/components/about.vue